import React, { useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { DataContext, TemplateContext } from '../pagesMains/GravesManagers/Graves';
import CustomCard from '../../reports/summery/detais_new/details_new';
import useQueryGraves from '../../../database/filters/queriesGrave';
import useQueries from '../../../database/useQueries';
import ColumnOrderingGrid from '../../template/table';
import { onClickRow, mapFieldValues } from '../plagins/utility';
import { GlobalContext } from '../../../App';
import { useEffect } from 'react';
import { useState } from 'react';
import ConfirmationDialog from '../plagins/dialogs/ConfirmationDialog';
import { createFetchDataServer, createFetchDataServerWithCallback, fetchDataFromServerFullWithCallback, getTableData } from '../../../database/fetchData';

const PlotDetail = () => {
  // קבלת ערכים מהסטור
  const optionsFields = useSelector((state) => state.dataOptionsFieldsHe.data);
  const columns = useSelector((state) => state.columnsTableAreaGraves.data);
  const properties = useSelector((state) => state.columnsPropertiesPlots.data);

  const context = useContext(DataContext);
  const fetchDataServer = createFetchDataServer(context);
  // const fetchDataServerWithCallback = createFetchDataServerWithCallback(context);

  // טעינת היוזים לפונקציות עזר
  const { getSummaryByAreaGrave } = useQueryGraves();
  const { getEntitiesByAttr, removePlot } = useQueries();

  const [loading, setLoading] = useState(true); // מצב טעינה
 
  // ערכי הראוטר
  const navigate = useNavigate();
  const location = useLocation();
  const { value, summaries } = location.state || {};
  const { searchText, setTotalWidthContainer } = useContext(TemplateContext);
  const { token, setBreadcrumbs, breadcrumbs, setTitle } = useContext(GlobalContext);

const [myPlot, setMyPlot] = useState(context?.contextPlots?.find(plot => plot?.unicId === value?.unicId) || value);
useEffect(() => {
  setMyPlot(context?.contextPlots?.find(plot => plot?.unicId === value?.unicId) || value)
}, [context?.contextPlots]);


  useEffect(() => {
    setTotalWidthContainer(1400);
    setTitle(`חלקה ${myPlot?.plotNameHe}`);

    const pathSegments = location.pathname.split('/').filter(Boolean); // חילוץ המקטעים מה-URL

    // ביצוע פעולות על פי המקטעים
    if (pathSegments.length > 0) {
      const subSegments = pathSegments.slice(1); // לדוגמה, ['4', '3', '2']

      let temp = breadcrumbs;
      // שמירת האיברים הראשונים עד לאורך של subSegments
      temp = temp.slice(0, subSegments.length);
      temp = [
        ...temp,
        {
          id: (temp.length > 0 ? temp[temp.length - 1].id : 0) + 1,
          name: myPlot?.plotNameHe,
          url: location.pathname,
          state: location.state
        }
      ];

      setBreadcrumbs(temp);
    }
  }, [loading, location.pathname]);

  // סטייט לפופאפ האישור
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

  const handleButtonUpdate = () => {
    navigate('/plotUpdate', { state: { value: myPlot } });
  };

  const mappedData = mapFieldValues(context?.contextAreaGraves?.filter(areaGrave => areaGrave?.plotId === myPlot?.unicId), optionsFields);

  const handleOpenConfirmDialog = () => {
    setOpenConfirmDialog(true);
  };

  // כאשר המשתמש עונה בדיאלוג
  const handleAnswer = (answer) => {
    setOpenConfirmDialog(false);
    if (answer) {
      // כאן מבצעים את פעולת המחיקה
      // const plot = getEntityByAttr(localPlots, 'unicId', value?.unicId);
      // const areaGraves = getEntitiesByAttr(localAreaGraves, 'plotId', plot?.unicId)
      // areaGraves.forEach(item => { removeAreaGrave({ id: item?.unicIc }) });
      removePlot({ id: myPlot?.id });
      navigate(-1);
    }
  };

  // הסרת אחוזת קבר
  const deleteItem = () => {
    // const plot = getEntityByAttr(localPlots, 'unicId', value?.unicId);
    const areaGraves = getEntitiesByAttr(context?.contextAreaGraves, 'plotId', myPlot?.unicId);
    // const graves = localGraves.filter(grave =>
    //   areaGraves.some(areaGrave => areaGrave.gravesList.includes(grave.areaGraveId))
    // );

    let checkEntity = areaGraves;
    // graves.forEach(grave => {
    //   let temp = getEntityByAttr(localBurials, 'graveId', grave?.unicId) ||
    //     getEntityByAttr(localPurchases, 'graveId', grave?.unicId) || null
    //   if (temp !== null) {
    //     checkEntity = [...checkEntity, temp]
    //   }
    // });
    if (checkEntity?.length > 0) {
      alert('לא ניתן להסיר, קיים תיק מקושר');
    } else {
      handleOpenConfirmDialog(); // פותח את הדיאלוג לאישור המחיקה
    }
  };

  useEffect(() => {
    async function loadTableData() {
      const localTempData = await getTableData('myDatabase', 'myStore');
      if (localTempData) {
        const dataPlots = localTempData.find((item) => item.name === 'dataPlots')  
        const dataAreaGraves = localTempData.find((item) => item.name === 'dataAreaGraves')   
        if (dataPlots && dataAreaGraves) {
          setLoading(false);
        }
      }
      else {
        const handlePartialUpdate = (tableName) => {
          console.log(`Partial update received for table: ${tableName}`);
          setLoading(false);
        };
        // fetchDataServerWithCallback(['plots'], token, handlePartialUpdate);
  
        fetchDataServer(['areaGraves'], token);
      }
    }
    loadTableData();
  }, []);

  return (
    <>
      <CustomCard data={properties} value={myPlot} summaries={summaries} handleEdit={handleButtonUpdate} handleDelete={deleteItem} />
      <ColumnOrderingGrid rows={mappedData} columns={columns.filter((prop) => prop.show)} searchText={searchText} onRowSelect={(row) => onClickRow(row, getSummaryByAreaGrave, navigate)} />

      {/* דיאלוג לאישור מחיקה */}
      <ConfirmationDialog open={openConfirmDialog} title="אישור מחיקה" content="האם את/ה בטוח שברצונך להסיר את חלקת הקברים?" onAnswer={handleAnswer} />

      <p>
        Location: <span style={{ fontFamily: "'Courier New', Courier, monospace" }}>/PlotDetail</span>
      </p>
    </>
  );
};

export default PlotDetail;
